import { getNumber, getJson, numConvert } from "../../../method";

export function compute(data) {

    return data
}




// WEBPACK FOOTER //
// ./src/components/otherHeadquartersForms/4_2Year/compute.js